export default __webpack_public_path__ + "static/media/PowerPoleMk1.256.3dbd10a5.png";